import { Injectable } from '@angular/core';
import { DhhpApiService } from './dhhp-api.service';
import { environment } from '../../../environments/environment';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PlatformService {
  gridToPrint:any;
  isDigitalAsset:boolean=false;
  constructor(private service: DhhpApiService) { }
  getPickList(postData) {
    return this.service.getApi(environment.PLATFORM_AUTH_Register + "Users/GetPickList");
  }
  postInstitution(postData) {
    return this.service.postApi(environment.PLATFORM_AUTH_Register + "Users/RegisterCustomer", postData);
  }
  postPHUser(postData) {
    return this.service.postApi(environment.PLATFORM_AUTH_Register + "Users/RegisterHartmann", postData);
  }
  signInPHUser(postData) {
    return this.service.postApi(environment.PLATFORM_AUTH_Register + "Account/HartmannLogInAuthUserDetails", postData);
  }
  phUserFacilitySubscription(postData) {
    return this.service.getApi(environment.PLATFORM_AUTH_Register + "Account/HartmannLogInAuthFacilitySubscription?userId=" + postData);
  }
  logout(formData){
    return this.service.postApi(environment.PLATFORM_AUTH + 'Account/LogOut',formData, true);
  }
  getStates(country) {
    return this.service.getApi(environment.API_ENDPOINT_Facility + "MasterData/GetCountryStates/"+country);
  }
  getFacilityAppSubscriptionAgreement(formData) {
    return this.service.postApi(environment.API_ENDPOINT_Facility + "MasterData/GetFacilityAppSubscriptionAgreement", formData);
  }
  getLanguageByCountry(countryVal){
    return this.service.getApi(environment.API_ENDPOINT_Facility + "MasterData/GetLanguagesByCountry/"+countryVal);
  }
  getLanguageSupported(countryVal){
    return this.service.getApi(environment.API_ENDPOINT_Facility + "MasterData/GetLanguagesByCountry/"+countryVal);
  }
  getDefaultLanguage(countryVal){
    return this.service.getApiString(environment.API_ENDPOINT_Facility + "MasterData/GetDefaultLanguagesByCountry/"+countryVal);
  }
  getScreenSetting(countryId) {
    return this.service.getApi(environment.API_ENDPOINT_Facility + "MasterData/GetScreenSetting/"+countryId);
  }
  getFlags() {
    return this.service.getApi(environment.API_ENDPOINT_Facility + "MasterData/GetSupportedCountryFlags");
  }
  initialPasswordPost(data){
    return this.service.postApi(environment.PLATFORM_AUTH + "Account/InititateFirstTimePasswordReset", data);
  }
  refreshTokenHartmann(postData) {
    return this.service.postApi(environment.PLATFORM_AUTH + "Account/RefreshTokenByHartmannUser", postData);
  }
  refreshTokenInstitution(postData) {
    return this.service.postApi(environment.PLATFORM_AUTH + "Account/RefreshToken", postData);
  }
  getPasswordResetURL(postData){
    return this.service.postApi(environment.PLATFORM_AUTH + "Account/AdminInitiatePasswordReset", postData);
  }
  sendCopyMail(postData){
    return this.service.postApi(environment.PLATFORM_AUTH + "Account/SendPasswordResetEmail", postData);
  }
  getAllApps(id) {
    return this.service.getApi(environment.PLATFORM_AUTH + "AppManager/GetAppsDetailsByUserName/"+id);
  }
  getAppLookUp() {
    return this.service.getApi(environment.PLATFORM_AUTH + "AppManager/GetAppLookUp",true);
  }
  getAppRegisterLookUp() {
    return this.service.getApi(environment.PLATFORM_AUTH + "AppManager/GetRegistrationAppLookUp",true);
  }
  getPrivacyPolicyByCountry(postData) {
    return this.service.postApi(environment.API_ENDPOINT_Facility + "MasterData/GetPrivatePolicy",postData);
  }
  getTermsByCountry(postData) {
    return this.service.postApi(environment.API_ENDPOINT_Facility + "MasterData/GetTermConditionPolicy",postData);
  }
  getAppFunctionLookUp(reqData) {
    return this.service.postApi(environment.PLATFORM_AUTH_Register + "Users/GetPickList",reqData);
  }
  getAllUsers(data){
    return this.service.postApi(environment.PLATFORM_AUTH + "Users/GetUsers",data,true);
  }
  getUserDetails(id){
    return this.service.getApi(environment.PLATFORM_AUTH + "Users/GetRegisteredUser/"+id);
  }
  postUserDetail(postData) {
    return this.service.postApi(environment.PLATFORM_AUTH + "Users/UpdateUserDetails", postData);
  }
  CreateUser(postData) {
    return this.service.postApi(environment.PLATFORM_AUTH + "Users/CreateUser", postData);
  }
  getAllPlatformUsers(data){
    return this.service.postApi(environment.PLATFORM_AUTH + "Users/GetUserManagementFullList",data);
  }
  getAllPlatformUsersPaginated(data){
    return this.service.postApi(environment.PLATFORM_AUTH + "Users/GetUserManagementListPaginated",data);
  }
  getPlatformUserDetails(id){
    return this.service.getApi(environment.PLATFORM_AUTH + "Users/GetUser/"+id);
  }
  getFacilityHierarchy(){
    return this.service.getApi(environment.API_ENDPOINT_FacilityVersion + "Facility/GetFacilitiesByHierarchy",true);
  }
  updateUserRoleActivation(data){
    return this.service.putApi(environment.API_ENDPOINT_PLATFORM + "UserManagement/UpdateUserRoleActivation",data);
  }
  updateUserRoleAndFacility(data){
    return this.service.putApi(environment.PLATFORM_AUTH + "Users/UpdateUserRoleandFacilities",data);
  }
  getPlatformMasterLookUpData(){
    return this.service.getApi(environment.API_ENDPOINT_PLATFORM + "UserManagement/GetPlatformLookUpData",true);
  }
  uploadUserProfileImage(postData) {
    return this.service.imgPostApi(environment.PLATFORM_AUTH + "Users/UploadUserProfileImage", postData);
  }
  getAllPendingApprovals(postData, countryCode){
    return this.service.getApi(environment.API_ENDPOINT_PLATFORM + "UserManagement/GetUserApprovalList?countryCode=" + countryCode,true);
  }
  getAppRolesLookUps(){
    return this.service.getApi(environment.PLATFORM_AUTH + "AppManager/GetAppRolesLookUpData");
  }
  getAppManagerListByCountry(){
    return this.service.getApi(environment.PLATFORM_AUTH + "AppManager/GetAppManagerDetailsByUser");
  }

  getFacilitySubscriptionDetails(postData){
    return this.service.postApi(environment.PLATFORM_AUTH + "AppSubscription/GetFacilitySubscriptionDetails",postData);
  }
  getFacilitySubscriptionPlansforApp(appid,facilityCRMId,country){
    return this.service.getApi(environment.PLATFORM_AUTH + `AppSubscription/GetFacilitySubscriptionPlansforApp/${appid}/${facilityCRMId}/${country}`);
  }
  getFacilitySubscriptionPlansforAppWithAgreement(appid,facilityCRMId,country){
    return this.service.getApi(environment.PLATFORM_AUTH + `AppSubscription/GetFacilitySubscriptionPlanswithAgreement/${appid}/${facilityCRMId}/${country}`);
  }
  updateFacilitySubscriptionSetup(flag,commData) {
    return this.service.putApi(environment.PLATFORM_AUTH + "AppSubscription/UpdateFacilitySubscriptionSetup/"+flag, commData);
  }
  deleteFacilitySubscriptionSetup(id) {
    return this.service.deleteApi(environment.PLATFORM_AUTH + `AppSubscription/RemoveFacilitySubscriptionSetup/${id}`);
  }
  updateApplicationSettings(commData) {
    return this.service.putApi(environment.PLATFORM_AUTH + "AppManager/UpdateApplicationSettings", commData);
  }
  postSubscriptionApproval(postData){
    return this.service.postApi(environment.PLATFORM_AUTH + "AppSubscription/AppSubScriptionApproval",postData);
  }
  appSubScriptionAgreementApproval(postData){
    return this.service.postApi(environment.PLATFORM_AUTH + "AppSubscription/AppSubScriptionAgreementApproval",postData);
  }
  postSubscriptionRoleAssign(postData){
    return this.service.postApi(environment.PLATFORM_AUTH + "AppSubscription/SubscriptionRoleAssignmentFromPlatfrom",postData);
  }
  postRegistrationApproval(postData){
    return this.service.postApi(environment.PLATFORM_AUTH_Register + "Users/RegistrationApproval",postData);
  }
  postRegistrationRoleAssign(postData){
    return this.service.postApi(environment.PLATFORM_AUTH + "Users/UserRegistrationRoleAssignment",postData);
  }
  postServiceApproval(postData){
    return this.service.postApi(environment.API_ENDPOINT_PLATFORM + "UserManagement/ServiceSubscriptionApproval",postData);
  }
  postDeServiceApproval(postData){
    return this.service.postApi(environment.API_ENDPOINT_PLATFORM + "UserManagement/ServiceDeSubscriptionApproval",postData);
  }
  validateCustomerAccount(postData){
    return this.service.postApi(environment.PLATFORM_AUTH + "Users/ValidateCustomerAccount",postData);
  }
  login(loginData) {
    return this.service.postApi(environment.PLATFORM_AUTH + "Account/LogInAuth",loginData);
  }

  updateConsent(formData) {
    return this.service.postApi(environment.PLATFORM_AUTH + "Users/UpdateUserConsentAgreement",formData);
  }

  getAllFacilities(){
    return this.service.getApi(environment.API_ENDPOINT_FacilityVersion + "Facility/GetFacilities");
  }
  getFacilityById(id) {
    return this.service.getApi(environment.API_ENDPOINT_Facility + "Facility/GetFacilityById/" + id);
  }
  getFacilityByCRMId(id) {
    return this.service.getApi(environment.API_ENDPOINT_FacilityVersion + "Facility/GetFacilityByCRMId/" + id);
  }
  updateFacility(updateurl, postData) {
    return this.service.putApi(updateurl, postData);
  }
  deleteTimeBlock(deleteUrl) {
    return this.service.deleteApi(deleteUrl);
  }
  addTimeBlock(facilityId,timeBlockData){
    return this.service.postApi(environment.API_ENDPOINT_Facility + 'FacilityDetail/AddTimeBlockByFacilityId/'+ facilityId,timeBlockData);
  }
  editTimeBlock(timeBlockId,timeBlockData){
    return this.service.putApi(environment.API_ENDPOINT_Facility + 'Facility/UpdateFacilityTimeBlock/'+ timeBlockId,timeBlockData);
  } 
  getFacilityExportDetails(institutionid, fromDate,toDate) {
    return this.service.getApi(environment.API_ENDPOINT_Facility + "FacilityDetail/GetFacilityDetailsByInstitutionAndDateRange/" + institutionid+"/"+fromDate+"/"+toDate);    
  }

  getInstitutionList(){
    return this.service.getApi(environment.API_ENDPOINT_Facility + "Facility/GetFacilityLookUp");
  }
  //Application setup
  getAllApplication() {
    return this.service.getApi(environment.PLATFORM_AUTH + "AppManager/GetAllApps");
  }
  addNewApplication(formData){
    return this.service.postApi(environment.PLATFORM_AUTH + 'AppManager/CreateNewApp',formData);
  }
  updateExistingApplication(appId,formData){
    return this.service.postApi(environment.PLATFORM_AUTH + 'AppManager/UpdateApp/'+appId,formData);
  }
  uploadApplicationIcon(postData) {
    return this.service.imgPostApi(environment.PLATFORM_AUTH + "AppManager/UploadAppIcon", postData);
  }

  //Communication management

  postCommunication(commData) {
    return this.service.postApi(environment.PLATFORM_AUTH + "Notification/CreateNewAlert", commData);
  }
  updateCommunication(msgId,commData) {
    return this.service.postApi(environment.PLATFORM_AUTH + 'Notification/UpdateMessage/?messageId='+msgId, commData);
  }
  deleteCommunication(msgId) {
    return this.service.deleteApi(environment.PLATFORM_AUTH + 'Notification/DeleteMessagebyId/'+msgId);
  }
  getCommunicationData(principleName,appId=1)
  {
    var currentCountry = localStorage.getItem('countryVal');
    return this.service.getApi(environment.PLATFORM_AUTH + 'Notification/GetAllMessages/'+principleName+'/'+appId + '/' + currentCountry,true);
  }
  getCommunicationById(msgId)
  {
    return this.service.getApi(environment.PLATFORM_AUTH + 'Notification/GetMessagebyId/'+msgId,true);
  }
  getUsersByCountryId(countryId)
  {
    return this.service.getApi(environment.PLATFORM_AUTH + 'Users/GetUsersByCountry/'+countryId,true);
  }
  communicationFilter(filterObj) {
    return this.service.postApi(environment.PLATFORM_AUTH + "Notification/GetMessagesByFilter", filterObj);
  }
  getInstitutionListByUser(){
    return this.service.getApi(environment.PLATFORM_AUTH + "Notification/GetFaclitiesbyUsername");
  }
  //Digital asset library

  addNewDigitalAsset(digitalAssetData) {
    return this.service.postApi(environment.PLATFORM_AUTH + "CommunicationAssets/AddAssetLibrary", digitalAssetData);
  }
  getcommunicationAssetData(pName)
  {
    var currentCountry = localStorage.getItem('countryVal');
    return this.service.getApi(environment.PLATFORM_AUTH + 'CommunicationAssets/GetCommunicationAssets/'+pName + '/'+currentCountry,true);
  }
  uploadfile(file) {
    return this.service.imgPostApi(environment.PLATFORM_AUTH+"CommunicationAssets/UploadAsset", file);
  }

  //Search Text

  getSuggestionText(data){
    return this.service.postApi(environment.API_PLATFORM_SEARCH + "CognitiveSearch/SearchwithData",data);
  }
  getAutoCompleteText(data){
    return this.service.postApi(environment.API_PLATFORM_SEARCH + "CognitiveSearch/Autocomplete",data);
  }
  getSearchText(data){
    return this.service.postApi(environment.API_PLATFORM_SEARCH + "Search/SearchText",data);
  }
  //Subscription management

  postSubscriptionData(commData) {
    return this.service.postApi(environment.API_ENDPOINT_Facility + "SubscriptionPlan/CreateSubscriptionPlan", commData);
  }
  updateSubscriptionData(id,commData) {
    return this.service.putApi(environment.API_ENDPOINT_Facility + "SubscriptionPlan/UpdateSubscriptionPlan/"+id, commData);
  }
  getSubcriptionListData()
  {
    return this.service.getApi(environment.API_ENDPOINT_Facility + 'SubscriptionPlan/GetAllSubscriptionPlans',true);
  }
  getSubcriptionListDataByUserId(id)
  {
    return this.service.getApi(environment.API_ENDPOINT_Facility + 'SubscriptionPlan/GetAllSubscriptionPlans/'+id,true);
  }
  checkPlanNameExists(planName,userid)
  {
    return this.service.getApi(environment.API_ENDPOINT_Facility + 'SubscriptionPlan/CheckPlanNameExists/'+planName+'/'+userid);
  }
  searchFacility(data)
  {
    return this.service.postApi(environment.API_ENDPOINT_FacilityVersion + 'Facility/SearchFacility', data);
  }
  getSubcriptionAssetData(type)
  {
    return this.service.getApi(environment.PLATFORM_AUTH + 'CommunicationAssets/GetCommunicationAssetsByType/'+type,true);
  }
  getAllRoles()
  {
    return this.service.getApi(environment.PLATFORM_AUTH + 'Roles/GetAllRoles',true);
  }
  getRoleProfileById(id){
    return this.service.getApi(environment.PLATFORM_AUTH + 'Roles/GetRoleProfileById/'+id);
  }
  UpdateRoleProfiles(data){
    return this.service.postApi(environment.PLATFORM_AUTH + 'Roles/UpdateRoleProfiles',data);
  }
  AddPinToUserDashboard(data){
    return this.service.postApi(environment.API_ENDPOINT_PLATFORM + 'PintoUserDashboard/AddPinToUserDashboard',data);
  }
  GetPinnedDashboardAppsforUser(userid, userCountry){
    return this.service.getApi(environment.API_ENDPOINT_PLATFORM + `PintoUserDashboard/GetPinnedDashboardAppsforUser/${userid}/${userCountry}`,true);
  }
  RemovePinfromUserDashboard(id){
    return this.service.deleteApi(environment.API_ENDPOINT_PLATFORM + `PintoUserDashboard/RemovePinfromUserDashboard/${id}`);
  }

  //Application Management

  addApplicationManageData(formData){
    return this.service.postApi(environment.PLATFORM_AUTH + 'ApplicationManagement/AddNewApplicationRollout',formData);
  }
  getUpdateApplicationManageData(id){
    return this.service.getApi(environment.PLATFORM_AUTH + 'ApplicationManagement/GetApplicationDetailsById/'+id);
  }
  getApplicationManagemntInfo(){
    return this.service.getApi(environment.PLATFORM_AUTH + `ApplicationManagement/GetAllApplicationDetails`);
  }
  getAllApplicationReleaseDetails(id){
    return this.service.getApi(environment.PLATFORM_AUTH + `ApplicationManagement/GetAllApplicationDetails/`+id);
  }
  getApplicationLoadInfo(){
    return this.service.getApi(environment.PLATFORM_AUTH + `ApplicationConfiguration/GetAppConfigurations`);
  }
  getMasterDataDetails(data){
    return this.service.postApi(environment.API_ENDPOINT_PLATFORM + 'LookupMasterData/GetMasterDataDetails', data);
  }
  getSubcriptionData(id)
  {
    return this.service.getApi(environment.PLATFORM_AUTH + 'ApplicationManagement/GetAllSubscriptionPlans/'+id);
  }
  getRoleData()
  {
    return this.service.getApi(environment.PLATFORM_AUTH + 'ApplicationManagement/GetAllRolesforApplication');
  }
  getAssetListData(appId)
  {
    return this.service.getApi(environment.PLATFORM_AUTH + 'ApplicationManagement/GetApplicationAssetsById/'+appId);
  }
  getAssetfromFullUrl(fullUrl)
  {
    return this.service.postApi(environment.PLATFORM_AUTH + 'ApplicationManagement/DownloadApplicationAssetbyFullUrl',fullUrl);
  }
  /** Application rollout API's */
  getListofRolloutApps(countryId){
    return this.service.getApi(environment.PLATFORM_AUTH + 'ApplicationManagement/GetOnBoardedApplicationDetails/'+countryId);
  }
  updateRolloutAppDatas(formData){
    return this.service.postApi(environment.PLATFORM_AUTH + 'ApplicationManagement/AddApplicationRolloutCountrywise',formData);
  }
  getListofVerifiedApps(userid){
    return this.service.getApi(environment.PLATFORM_AUTH + 'ApplicationManagement/GetAllRolloutApplicationDetails/'+userid);
  }
  getRolloutDetailsInfo(rolloutId){
    return this.service.getApi(environment.PLATFORM_AUTH + 'ApplicationManagement/GetRolloutApplicationDetailsById/'+rolloutId);
  }
  onboardingEmailVerify(email){
    return this.service.getApi(environment.PLATFORM_AUTH + 'Users/UserLookUpByEmail/'+email);
  }

  /** Landing screens */
  getLandingScreenData(countryVal){
    return this.service.getApi(environment.PLATFORM_AUTH + 'ContentMangement/GetLandingPageContent/'+countryVal,true);
  }
  getContactDetailsInfo(countryVal){
    return this.service.getApi(environment.PLATFORM_AUTH + 'ContentMangement/GetHelpandSupportContactDetails/'+countryVal);
  }
  getHomeScreenData(countryVal){
    return this.service.getApi(environment.API_ENDPOINT_PLATFORM + 'ContentsManagement/GetHomePageContents/'+countryVal,false);
  }
  getAppManagerList(){
    return this.service.getApi(environment.PLATFORM_AUTH + 'AppManager/GetAppManagerByUser',true);
  }
  updateAppManagerItem(formData){
    return this.service.putApi(environment.PLATFORM_AUTH + 'AppManager/UpdateAppSettings',formData);
  }
  updateAppManagerItemByCountry(id,formData){
    return this.service.putApi(environment.PLATFORM_AUTH + 'AppManager/UpdateApplicationSettings/'+id,formData);
  }
  subscribeApp(formData){
    return this.service.postApi(environment.PLATFORM_AUTH + 'AppSubscription/AddSubScriptionRequest',formData);
  }
  subscribeAppDirectly(formData){
    return this.service.postApi(environment.PLATFORM_AUTH + 'AppSubscription/AddDefaultSubScriptionByClientApp',formData);
  }
  deSubscribeRequestToApp(formData){
    return this.service.postApi(environment.PLATFORM_AUTH + 'AppSubscription/AddDeSubScriptionRequest',formData);
  }
  deSubscribeCountApp(id){
    var currentCountry = localStorage.getItem('countryVal');
    return this.service.getApi(environment.PLATFORM_AUTH + 'AppSubscription/GetUserAppSubScriptionDetails/'+id +'/' + currentCountry);
  }
  deSubscribeApp(formData){
    return this.service.postApi(environment.PLATFORM_AUTH + 'AppSubscription/DesubscribeRequest',formData);
  }
  getFaqSupportData(countryVal){
    return this.service.getApi(environment.PLATFORM_AUTH + 'ContentMangement/GetHelpandSupportDetails/'+countryVal,true);
  }
  postFaqSupportData(formData){
    return this.service.postApi(environment.PLATFORM_AUTH + 'ContentMangement/AddHelpandSupport',formData);
  }
  updateFaqSupportData(id,formData){
    return this.service.postApi(environment.PLATFORM_AUTH + 'ContentMangement/UpdateHelpandSupportDetails/'+id,formData);
  }
  updateLandingPageData(id,formData){
    return this.service.postApi(environment.PLATFORM_AUTH + 'ContentMangement/UpdateLandingPageContent/'+id,formData);
  }
  updateHomePageData(id,formData){
    return this.service.postApi(environment.PLATFORM_AUTH + 'ContentMangement/UpdateHomePageContent/'+id,formData);
  }
  getLetusHelpData(countryVal){
    return this.service.getApi(environment.PLATFORM_AUTH + 'ContentMangement/GetLetusHelpConfiguration/'+countryVal,true);
  }
  getHistorySupportData(userid){
    var currentCountry = localStorage.getItem('countryVal');
    return this.service.getApi(environment.PLATFORM_AUTH + 'ContentMangement/GetSupportTicketDetails/'+userid +'/'+currentCountry,true);
  }
  addSupportTicketData(formData){
    return this.service.postApi(environment.PLATFORM_AUTH + 'ContentMangement/AddSupportTicket',formData);
  }
  getLandingScreenAppInfo(appId){
    return this.service.getApi(environment.PLATFORM_AUTH + 'AppManager/GetAppManagerDetailsById/'+appId);
  }
  updateDropAppManager(formData){
    return this.service.putApi(environment.PLATFORM_AUTH + 'AppManager/UpdateAppDisplayOrder',formData);
  }
  updateDropPromoList(formData,id){
    return this.service.postApi(environment.PLATFORM_AUTH + 'ContentMangement/UpdateHomePagePromosOrder/'+id,formData);
  }
  /** User-Group */
  getUserGroupList(userId, countryCode){
    return this.service.getApi(environment.PLATFORM_AUTH + 'UserGroup/GetUserGroups/'+userId + '/' + countryCode,true);
  }
  /** User-Session-Management-Dashboard */
  getDashboardData(formData){
    return this.service.postApi(environment.PLATFORM_AUTH_Register + 'UserSession/GetUserSessionDashboard',formData);
  }
  getUserSession(formData){
    return this.service.postApi(environment.PLATFORM_AUTH_Register + 'UserSession/GetUserSessions',formData);
  }
  getPwdExpiredUsersList(formData) {
    return this.service.postApi(environment.PLATFORM_AUTH_Register + 'UserSession/GetPasswordExpiredUserAccounts',formData);
  }
  getNewUsersList(formData) {
    return this.service.postApi(environment.PLATFORM_AUTH_Register + 'UserSession/GetNewUserAccounts',formData);
  }
  getActiveUsersList(formData) {
    return this.service.postApi(environment.PLATFORM_AUTH_Register + 'UserSession/GetActiveUserAccounts',formData);
  }
  getInactiveUsersList(formData) {
    return this.service.postApi(environment.PLATFORM_AUTH_Register + 'UserSession/GetInactiveUserAccounts',formData);
  }
  getPendingApprovalUsersList(formData) {
    return this.service.postApi(environment.PLATFORM_AUTH_Register + 'UserSession/GetAppSubscriptionUserAccounts',formData);
  }
  getUserGroupDetailsId(groupId){
    return this.service.getApi(environment.PLATFORM_AUTH + 'UserGroup/GetUserGroupDetailsById/'+groupId);
  }
  postNewUserGroup(formData){
    return this.service.postApi(environment.PLATFORM_AUTH + 'UserGroup/CreateUserGroup',formData);
  }
  updateUserGroup(groupId,formData){
    return this.service.postApi(environment.PLATFORM_AUTH + 'UserGroup/UpdateUserGroup/'+groupId,formData);
  }
  deleteUserGroup(id){
    return this.service.deleteApi(environment.PLATFORM_AUTH + 'UserGroup/DeleteUserGroup/'+id);
  }
  
  /** Communication Template API's */
  getCommunicationTemplateList(userId){
    var currentCountry = localStorage.getItem('countryVal');
    return this.service.getApi(environment.PLATFORM_AUTH + 'CommunicationTemplate/GetAllCommunicationTemplatesbyUserId/'+userId + '/' + currentCountry,true);
  }
  postCommunicationTemplate(formData){
    return this.service.postApi(environment.PLATFORM_AUTH + 'CommunicationTemplate/CreateCommunicationTemplate',formData);
  }
  updateCommunicationTemplate(templateId,formData){
    return this.service.postApi(environment.PLATFORM_AUTH + 'CommunicationTemplate/UpdateCommunicationTemplate/'+templateId,formData);
  }
  deleteCommunicationTemplate(id){
    return this.service.deleteApi(environment.PLATFORM_AUTH + 'CommunicationTemplate/DeleteCommunicationTemplatebyId/'+id);
  }
  //API Testing services
  getAPITestingServiceDashboard(formData){
    return this.service.postApi(environment.API_TESTING_SERVICES + 'APITesting/GetAPITestReport', formData);
  }
 
  getScenarioTestingServiceDashboard(formData){
    return this.service.postApi(environment.API_TESTING_SERVICES + 'APITesting/GetScenarioReport', formData);
  }
  getAPIHealthDashboard(formData){
    return this.service.postApi(environment.API_TESTING_SERVICES + 'APITesting/GetAPIHealthReport', formData);
  }
}